/**
 * Module Control Utility
 * Controls which modules are enabled/disabled based on environment variables
 */

const MODULE_MAP = {
  repositories: 'REPOSITORIES',
  cars: 'CARS',
  suppliers: 'SUPPLIERS',
  deliveryMans: 'DELIVERY_MANS',
  pickupeurs: 'PICKUPEURS',
  managers: 'MANAGERS',
  staff: 'STAFF',
  orders: 'ORDERS',
  orderSearchHistory: 'ORDER_SEARCH_HISTORY',
  pickups: 'PICKUPS',
  deliveryNotes: 'DELIVERY_NOTES',
  roadmaps: 'ROADMAPS',
  payments: 'PAYMENTS',
  invoices: 'INVOICES',
  transferVouchers: 'TRANSFER_VOUCHERS',
  returnVouchers: 'RETURN_VOUCHERS',
  toBeReimbursedVouchers: 'TO_BE_REIMBURSED_VOUCHERS',
  weights: 'WEIGHTS',
  synchronization: 'SYNCHRONIZATION',
  reporting: 'REPORTING',
  exchange: 'EXCHANGE',
  requestPartner: 'REQUEST_PARTNER',
  support: 'SUPPORT',
  returnReasonTypes: 'RETURN_REASON_TYPES',
  ticketCategories: 'TICKET_CATEGORIES',
  expenses: 'EXPENSES',
  governorates: 'GOVERNORATES',
  delegations: 'DELEGATIONS',
  localities: 'LOCALITIES',
  // Parent-level modules (set false to hide entire section)
  localisation: 'LOCALISATION',
  users: 'USERS',
  settings: 'SETTINGS',
  // Parent reporting module
  reportingParent: 'REPORTING',
  // Reporting sub-modules
  reportingWeeklyPayments: 'REPORTING_WEEKLY_PAYMENTS',
  reportingStates: 'REPORTING_STATES',
  reportingSupplierPerformance: 'REPORTING_SUPPLIER_PERFORMANCE',
  reportingTopDrivers: 'REPORTING_TOP_DRIVERS',
  reportingTurnover: 'REPORTING_TURNOVER',
}

/**
 * Check if a module is enabled
 * @param {string} moduleName - The name of the module (camelCase key from MODULE_MAP)
 * @returns {boolean} - True if module is enabled, false otherwise
 */
export const isModuleEnabled = moduleName => {
  const envKey = MODULE_MAP[moduleName]
  if (!envKey) {
    console.warn(`Module "${moduleName}" not found in MODULE_MAP`)
    return false
  }
  const envVar = process.env[`VUE_APP_MODULE_${envKey}`]
  return envVar === 'true' || envVar === true
}

/**
 * Get all enabled modules
 * @returns {object} - Object with module names as keys and enabled status as values
 */
export const getEnabledModules = () => {
  const enabledModules = {}
  Object.keys(MODULE_MAP).forEach(moduleName => {
    enabledModules[moduleName] = isModuleEnabled(moduleName)
  })
  return enabledModules
}

/**
 * Get all module names
 * @returns {array} - Array of all module names
 */
export const getModuleNames = () => Object.keys(MODULE_MAP)

export default {
  isModuleEnabled,
  getEnabledModules,
  getModuleNames,
  MODULE_MAP,
}
